<template>
    <div class="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div class="bg-white rounded-lg shadow-lg max-w-md w-full py-12 px-8 overflow-hidden">
            <h2 class="text-center text-3xl font-extrabold text-gray-900">Sign in to your account</h2>
            <p class="text-center text-sm text-gray-600">Or <router-link to="/register" class="font-medium text-green-900 hover:text-green-700">create your free account</router-link></p>
            <form action="#" method="POST">
                <input type="hidden" name="remember" value="true">
                <div class="rounded-md shadow-sm mt-6 mb-4">
                    <div>
                        <label for="email-address" class="sr-only">Email address</label>
                        <input id="email-address" name="email" type="email" autocomplete="email" required class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="Email address" v-model="cred.email">
                    </div>
                    <div>
                        <label for="password" class="sr-only">Password</label>
                        <input id="password" name="password" type="password" autocomplete="current-password" required class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="Password" v-model="cred.password">
                    </div>
                </div>

                <div class="flex items-center justify-between mb-4">
                    <div class="flex items-center">
                        <input id="remember_me" name="remember_me" type="checkbox" class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
                        <label for="remember_me" class="ml-2 block text-sm text-gray-900">Remember me</label>
                    </div>
                    <div class="text-sm">
                        <a href="#" class="font-medium text-green-900 hover:text-green-700">Forgot your password?</a>
                    </div>
                </div>

                <div>
                    <button type="submit" class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-900 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="login($event)">Sign in</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import auth from '@/auth';
import baseApi from '@/baseApi';
import router from '@/router';
import store from '@/store';

export default {
    name: 'Login',
    components: {},
    data(){
        return {
            cred: {
                email: '',
                password: ''
            }
        }
    },
    methods: {
        login(event) {
            event.preventDefault();
            baseApi().post('/auth/login', this.cred).then((response) => {
                if (response.data.success) {
                    store.dispatch('Auth/SET_AUTH_USER', response.data.user.user);
                    store.dispatch('Auth/SET_TOKEN', response.data.user.token);
                    store.dispatch('Auth/SET_AUTH', true);
                    localStorage.setItem('token', response.data.user.token.value);
                    router.push('/dashboard');
                }
            })
        },
    }
}
</script>
